import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  secondLevelTab: {
    backgroundColor: themeColor.white,
    marginRight: 10,
    borderRadius: 2,
    border: `1px solid ${themeColor.secondaryLight}`,
    height: '7.29vh',
    color: theme.palette.info.dark,
    letterSpacing: '0.02vw',
    lineHeight: '2.6vh',
    width: 'auto',
    minWidth: '10vw',
    maxWidth: '11vw',
    padding: '0 1.5vw',
    '& span': {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      fontWeight: 500,
      letterSpacing: '0.1vw',
      fontSize: vh(1.6),
      '@media (max-width: 1024px) and (max-height: 576px)': {
        fontSize: vh(1.45),
      },
      lineHeight: '2.08vh',
      hyphens: 'auto',
      width: '100%',
      overflowWrap: 'break-word',
      textTransform: 'uppercase',
      color: themeColor.defaultTextColor,
    },
    '&.Mui-selected': {
      border: `solid ${theme?.configColors?.secondaryColor || themeColor.secondaryMain}`,
      color: themeColor.defaultTextColor,
    },
    '&.Mui-disabled': {
      opacity: 0.4,
    },
  },
  actionButton: {
    marginBottom: '1.5vh',
    border: `solid 1px ${themeColor.lightgray} !important`,
    width: '100%',
    height: 'auto',
    paddingLeft: '1vw',
    paddingRight: '1vw',
    minWidth: 'auto',
    overflow: 'hidden',
    display: 'inline-block',
    whiteSpace: 'normal',
    textOverflow: 'ellipsis',
  },
  labelText: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    fontWeight: 500,
    letterSpacing: '0.1vw',
    fontSize: vh(1.6),
    '@media (max-width: 1024px) and (max-height: 576px)': {
      fontSize: vh(1.45),
    },
    lineHeight: '2.08vh',
    hyphens: 'auto',
    width: '100%',
    overflowWrap: 'break-word',
  },
  autoTopMargin: {
    marginTop: 'auto',
    height: '5vh',
  },
  buttonsCustomContainer: {
    height: '61vh',
    width: '9vw',
  },
  allTabsContainer: {
    display: 'block',
    '& >*:first-child': {
      marginLeft: '1vw',
    },
    '& >*:last-child': {
      marginRight: '1vw',
    },
  },
  customTabs: {
    margin: '2vh',

    '& >*:first-child': {
      boxShadow: `8px 0px 8px 1px ${themeColor.lightBackground},
        -5px 10px 5px 2px ${themeColor.lightBackground},
        -5px -10px 5px 2px ${themeColor.lightBackground}`,
      opacity: 100,
      zIndex: 999,
      marginLeft: '1vw',
      width: '2vw',
      minWidth: '2vw',
    },

    '& >*:last-child': {
      boxShadow: `-8px 0px 8px 1px ${themeColor.lightBackground},
        -5px 10px 5px 2px ${themeColor.lightBackground},
        -5px -10px 5px 2px ${themeColor.lightBackground}`,
      opacity: 100,
      zIndex: 999,
      marginRight: '1vw',
      width: '2vw',
      minWidth: '2vw',
    },
  },
  scrollButton: {
    minWidth: '4.09vw',
    height: '7.09vh',
    '&.Mui-disabled': {
      color: themeColor.subheaderLight,
    },
  },
  buttonContainerSmallForm: {
    flexDirection: 'row',
    display: 'grid',
  },
  buttonContainer: {
    flexDirection: 'column',
    display: 'flex',
  },
  buttonStyleSmallForm: {
    marginRight: '1vw',
    minWidth: '10vw',
  },
}));
